import React from 'react';
import classNames from 'classnames';
import useActiveTab from '@wolffun/shared/src/hooks/useActiveTab';
import styles from './styles.module.scss';

const TabBar = ({
  className,
  tabs,
  selected,
  onSelected
}) => {
  const {
    lineRef,
    refs
  } = useActiveTab({
    selectedKey: selected,
    data: tabs,
    onFilter: item => item === selected
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, tabs.map((tab, index) => /*#__PURE__*/React.createElement("div", {
    key: tab,
    className: classNames(styles.tabItem, selected === tab && styles.selected),
    onClick: () => onSelected(tab),
    ref: ref => {
      if (ref) {
        refs.current[index] = ref;
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, tab))), /*#__PURE__*/React.createElement("div", {
    className: styles.line,
    ref: lineRef
  }));
};

export default TabBar;